import ProductCard from "../SmallComponents/ProductCard";
import images from "../../assets/images/assets";
import PropTypes from "prop-types";

// FrontEnd - Dummy Data
// import { productsData } from "../../assets/data/data";

// Backend Product Data
// import { ShopContext } from "../Context/ShopContext";
// import { useContext } from "react";

const GridSection = ({ products }) => {
  // console.log("Collections Page: ", products);

  const productsPerPage = [...products].slice(0, 12);

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 md:px-4 lg:px-4 mt-10 bg-transparent gap-4 lg:gap-5 lg:gap-y-20 py-8 md:py-16 lg:py-18  relative">
      {productsPerPage.map(({ _id, name, price, images }) => (
        <ProductCard
          key={_id}
          _id={_id}
          name={name}
          price={price}
          cover={images[0]}
        />
      ))}

      {/* Decorative Blur */}
      <img
        src={images.blur_2}
        alt="blur"
        className="absolute -left-20 top-0 saturate-150 mirror-x lg:-top-40 lg:-left-50"
      />
      <img
        src={images.blur_3}
        alt="blur"
        className="absolute -right-20 -bottom-50 md:-bottom-40 lg:-right-90 saturate-200 "
      />
    </div>
  );
};

GridSection.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      images: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
};

export default GridSection;
